/*
 * Move the product gallery to the selected variant's image.
 * The theme only un-hides the image, which does nothing inside the slider,
 * so the photo never changed when a colour swatch was clicked.
 */
(function () {
  function goToVariantImage(variant) {
    if (!variant) return;
    var media = variant.featured_media || variant.featured_image;
    if (!media) return;
    var id = String(media.id);

    var $slide = jQuery('[data-image-id="' + id + '"]').first();
    if (!$slide.length) return;

    var $gallery = $slide.closest('.slick-initialized');
    if ($gallery.length) {
      var index = $slide.closest('[data-slick-index]').attr('data-slick-index');
      if (index !== undefined) {
        $gallery.slick('slickGoTo', parseInt(index, 10));
      }
      return;
    }

    // Layouts without a slider: scroll the image into view instead.
    var el = $slide.get(0);
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function init() {
    if (!window.jQuery) return;
    jQuery(document).on('variantChange', function (event) {
      goToVariantImage(event.variant);
    });
  }

  if (window.jQuery) {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
